import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'fb-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FbLoaderComponent {
  @Input() message: string;
  @Input() type: 'spinner' | 'loader' = 'loader';
  @Input() size: number = 80;
  @Input() color: 'primary' | 'secondary' = 'primary';
}
